// noinspection DuplicatedCode
import { useAppState } from "./app-state";

export const useAppLocale = () => {
    const {state} = useAppState();

    return {
        locale: state.locale,
        locales: state.locales,
        languages: state.languages,
        localeName: state.locales[state.locale].name,
        acceptLanguage: state.locales[state.locale].lang+';'+state.locale+';q=0.9',
        // getLocale : () => {
        //     const locale = sessionStorage.getItem('locale');
        //     return locale != null ? locale : state.locale;
        // },
        // setLocale : (locale) => {
        //     sessionStorage.setItem('locale', locale);
        // },
        changeLocale: (locale) => {
            if (locale !== state.local) {
                fetch("/ui/lang/" + locale,{method:'POST'})
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.success) {
                            document.location.reload(true);
                        }
                    })
                    .catch((error) => {
                        // TODO: Global Hata yakalama
                        console.error('Error:', error);
                    });
            }
        }
    }
}
